module.exports = __webpack_public_path__ + "images/application/stats-empty-links-594ecf90.jpg";